import { h } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import InfoElement from './info-element'
import SingleBankRow from './single-bank-row'
import { CalculatorSavings } from 'models/apps'
import { BankData } from 'src/assets/scripts/models/market'
import InteractiveElements from './interactive-chart-elements'
import { formatNumber } from 'utils/format-number'
import { STATIC_EXCHANGE_RATES } from '../config'

interface MainChartViewProps {
  incomingBanksData: BankData[]
  direction: string
  value: string
  buyCurrency: string
  sellCurrency: string
  savings: CalculatorSavings
}

const FIXED_BANK_LIST = ['bzwbk', 'mbank', 'pkobp']

const MainChartView = ({
  incomingBanksData,
  savings,
  direction,
  value,
  buyCurrency,
  sellCurrency,
}: MainChartViewProps) => {
  const [banksData, setBanksData] = useState<BankData[]>(STATIC_EXCHANGE_RATES)
  const [actualBanksListToDisplay, setActualBanksListToDisplay] = useState<BankData[]>(STATIC_EXCHANGE_RATES)
  const [wtBankData, setWtBankData] = useState<BankData>(STATIC_EXCHANGE_RATES[0])
  const [isOtherBanksData, setIsOtherBanksData] = useState<boolean>(false)

  const sortBankData = (a: BankData, b: BankData): number => Number(a.amount) - Number(b.amount)

  const getBanksDataWithoutWT = (banksData: BankData[]): BankData[] => banksData.filter((bank) => bank.bank_id !== 'wt')

  const getActualBanksList = (banksData: BankData[]) => {
    let actualBanksDataToDisplay = []
    if (banksData.length === 1) {
      setIsOtherBanksData(false)
      return
    }
    FIXED_BANK_LIST.forEach((bankId) => {
      const bankData = banksData.find((data) => data.bank_id === bankId)
      if (bankData) actualBanksDataToDisplay = [...actualBanksDataToDisplay, bankData]
    })
    setActualBanksListToDisplay([...actualBanksDataToDisplay])
  }

  const getWtBankData = (banksData: BankData[]): void => {
    setWtBankData(banksData.find((bank) => bank.bank_id === 'wt'))
  }

  const isForeingBanksData = (banksData: BankData[]): void => {
    setIsOtherBanksData(banksData.length > 1)
  }

  useEffect(() => {
    setBanksData(incomingBanksData)
    getActualBanksList(incomingBanksData)
    getWtBankData(incomingBanksData)
    isForeingBanksData(incomingBanksData)
  }, [incomingBanksData])

  return (
    <div className="calculator-chart__main-chart-holder">
      <div className="calculator-chart__capital-holders">
        <div className="calculator-chart__single-cell is-wide is-text">
          {direction === 'BUY' ? 'Kupując' : 'Sprzedając'} {formatNumber(value, 2)} {buyCurrency}{' '}
          {direction === 'BUY' ? 'zapłacisz' : 'otrzymasz'}:
        </div>
        <div className="calculator-chart__single-cell">Kurs:</div>
        <div className="calculator-chart__single-cell">Wartość:</div>
      </div>
      {banksData && (
        <SingleBankRow
          bankData={wtBankData}
          buyCurrency={buyCurrency}
          sellCurrency={sellCurrency}
          isFirstRow={true}
        />
      )}
      {isOtherBanksData &&
        actualBanksListToDisplay.map((bank) => (
          <SingleBankRow
            bankData={bank}
            buyCurrency={buyCurrency}
            sellCurrency={sellCurrency}
            key={bank.bank_id}
          />
        ))}
      {isOtherBanksData && savings && (
        <InteractiveElements
          banksData={getBanksDataWithoutWT(banksData).sort(sortBankData)}
          sellCurrency={sellCurrency}
          buyCurrency={buyCurrency}
          savings={savings}
        />
      )}
      {!isOtherBanksData && (
        <InfoElement
          sellCurrency={sellCurrency}
          buyCurrency={buyCurrency}
        />
      )}
    </div>
  )
}

export default MainChartView
